import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import Search from './Search';
import { resetContainerState } from 'src/store/common-slices/getContainerSlice';

const mapStateToProps = (state: RootState) => ({
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    resetContainerState: () => dispatch(resetContainerState())
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);